import * as braze from '@braze/web-sdk';
import { ErrorType, recordError } from '../models/apiWrappers/api/exceptions';

let brazeInitialized = false;

export const initBraze = () => {
  if (brazeInitialized) {
    recordError(ErrorType.HANDLED, 'You cannot init braze more than once');
    return;
  }

  const baseUrl = process.env.REACT_APP_BRAZE_BASE_URL;
  const apiKey = process.env.REACT_APP_BRAZE_API_KEY;

  if (!baseUrl || !apiKey) {
    recordError(ErrorType.HANDLED, 'Cannot init braze');
    return;
  }

  if (!brazeInitialized) {
    braze.initialize(apiKey, {
      baseUrl: baseUrl,
    });

    brazeInitialized = true;
    braze.openSession();
  }
};

export const setBrazeUserEmailAndSegment = (email: string, segment: string | null, enableProgram?: boolean) => {
  if (!brazeInitialized) {
    return;
  }
  const brazeUser = braze.getUser();
  brazeUser?.setEmail(email);
  brazeUser?.setCustomUserAttribute('signup_origin', 'web');
  if (segment) {
    brazeUser?.setCustomUserAttribute('segment', segment);
  }
  braze.logCustomEvent('web_quiz_email_added', {
    location: 'webOnboarding',
    healingProgram: enableProgram ? 'yes' : 'no',
  });
  braze.logCustomEvent('web_quiz_segment_added');
};

export const resetBrazeUser = () => {
  if (!brazeInitialized) {
    return;
  }
  braze.wipeData();
};

export const changeBrazeUser = (id: string) => {
  if (!brazeInitialized) {
    return;
  }
  braze.changeUser(id);
};
